var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('console-user-form',{attrs:{"console-type":"businessSolution","remote-state":_vm.remoteState,"allowNoFleetBookingChannel":true},on:{"createUser":_vm.createUser}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }